export function setLoadCursore (data) {
  return (dispatch) => {
    dispatch({type: 'LOAD_CURSORE_SET', data})
    return null;
  }
}

export function showModalPayment (status, user_id = null) {
  return (dispatch) => {
    dispatch({type: 'SHOW_MODAL_PAYMENT', status, user_id})
    return null;
  }
}




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/actions.js